import React, { useEffect, useState, useMemo } from 'react';
import { Radio } from 'antd';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DEFAULT_SIZE = 'default';

const useStyles = makeStyles(
  theme => {
    return {
      tabWrapper: {
        ...theme.flex.row,
        width: '312px',
      },
      tab: {
        ...theme.flex.fillCenter,
        fontSize: '14px',
        lineHeight: '24px',
        padding: '4px 12px',

        '& .ant-radio-button + span': {
          display: 'inline-flex',
          alignItems: 'center',
        },
      },
      topTabWrapper: {
        ...theme.flex.row,
        width: '100%',
        padding: 0,
        overflowX: 'auto',
      },
      btn: {
        ...theme.typography.body2,
        color: theme.colors.titleColor,
        display: 'inline-block',
        margin: 0,
        marginRight: '32px',
        padding: 0,
        paddingBottom: '12px',
        border: 0,
        outline: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        fontWeight: 400,
        '&:last-child': {
          margin: 0,
        },
      },
      selectedbtn: {
        borderBottom: '2px solid #38b2a6',
        color: theme.colors.mainGreen6,
      },
    };
  },
  { name: 'newTabs' },
);

const NewTabs = props => {
  const { defaultActiveKey, onChange, options, tabPosition, ...restProps } = props;
  const [chooseKey, setChooseKey] = useState(Number(defaultActiveKey));
  const radioGroupOnChange = e => {
    setChooseKey(e.target.value);
    onChange && onChange(e.target.value);
  };
  const classes = useStyles();
  useEffect(() => {
    if (defaultActiveKey !== undefined && defaultActiveKey !== chooseKey) {
      setChooseKey(defaultActiveKey);
    }
  }, [defaultActiveKey]);

  const onClick = item => {
    setChooseKey(options.indexOf(item));
  };
  const chooseItem = useMemo(() => options[chooseKey], [chooseKey]);
  return (
    <div>
      <If condition={!tabPosition}>
        <div {...restProps}>
          <Radio.Group
            size={DEFAULT_SIZE}
            defaultValue={chooseKey}
            value={chooseKey}
            onChange={radioGroupOnChange}
            className={classes.tabWrapper}
          >
            {options?.map(({ text, value, extra }) => (
              <Radio.Button value={value} className={classes.tab} key={`${text}-${value}`}>
                <span style={{ verticalAlign: 'middle' }}>{text}</span>

                <If condition={extra}>{extra}</If>
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </If>
      <If condition={tabPosition && tabPosition === 'top'}>
        <div className={classes.topTabWrapper}>
          <For of={options} each="item">
            <button
              className={classNames(`${classes.btn}`, {
                [classes.selectedbtn]: chooseItem?.value === item?.value,
              })}
              onClick={() => {
                onClick(item);
                onChange(item);
              }}
              key={`${item.text}`}
            >
              {item.text}
            </button>
          </For>
        </div>
      </If>
    </div>
  );
};

NewTabs.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  defaultActiveKey: PropTypes.number,
  tabPosition: PropTypes.string,
};

export default NewTabs;
